export class FirebaseUserModel {
  image: string;
  name: string;
  provider: string;

  constructor(){
    this.image = "";
    this.name = "";
    this.provider = "";
  }
}



// WEBPACK FOOTER //
// C:/Users/Administrator/Desktop/Hotel-Data/src/app/core/user.model.ts